import React from 'react';

import styles from './styles.mountainrange.module.scss';

function MountainRange() {
  return (
    <div className={styles.mountainRange}>
      <div className={styles.m01} />
      <div className={styles.m02} />
      <div className={styles.m03} />
      <div className={styles.m04} />
      <div className={styles.m05} />
      <div className={styles.m06} />
      <div className={styles.m07} />
      <div className={styles.m08} />
      <div className={styles.m09} />
      <div className={styles.m10} />
      <div className={styles.m11} />
      <div className={styles.m12} />
      <div className={styles.m13} />
    </div>
  );
}

export default MountainRange;
